export default __webpack_public_path__ + "static/media/legHold_concat.5c04794e.mp3";